var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuizz(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_1386_680)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 6,
    fill: "url(#paint0_linear_1386_680)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7233 21.5569C12.2337 21.5569 11.7745 21.5569 11.3146 21.5569C10.6209 21.5574 9.96535 21.4282 9.37989 21.0626C8.63797 20.5992 8.13886 19.9767 7.92969 19.1514C8.27794 19.2042 8.60712 19.2497 8.93406 19.3093C8.98678 19.3187 9.03949 19.3846 9.07089 19.4354C9.55878 20.2163 10.2637 20.6431 11.2546 20.6279C11.9113 20.618 12.568 20.6237 13.2252 20.6258C13.7748 20.6279 13.9845 20.8832 13.8146 21.3701C13.5959 21.9962 13.3553 22.6155 13.1069 23.285C13.4972 23.0758 13.8802 22.8901 14.2408 22.6725C15.0484 22.1856 15.7432 21.5804 16.3213 20.8623C16.4638 20.6849 16.6517 20.6373 16.8748 20.6373C17.508 20.6373 18.1417 20.6436 18.7737 20.6232C19.6743 20.5945 20.3159 20.1614 20.7432 19.4432C20.8279 19.301 20.912 19.2471 21.083 19.2575C21.3314 19.2727 21.5821 19.2612 21.8692 19.2612C21.7806 19.6132 21.6208 19.914 21.41 20.1896C20.7056 21.1123 19.741 21.5631 18.5281 21.5569C18.0822 21.5548 17.6364 21.5464 17.1911 21.5631C17.0779 21.5673 16.9343 21.6296 16.8619 21.7101C15.4919 23.239 13.7451 24.1977 11.6965 24.7056C11.4352 24.7705 11.203 24.6863 11.092 24.4912C10.9787 24.2924 11.023 24.067 11.2327 23.9027C12.0094 23.2918 12.4424 22.4926 12.7239 21.5563L12.7233 21.5569Z",
    fill: "#252525"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4164 16.1286C11.664 16.2657 11.8775 16.3843 12.1112 16.514C11.9849 16.757 11.8557 17.0053 11.706 17.2928C11.4153 17.1154 11.1325 16.9534 10.862 16.774C10.7373 16.6914 10.6345 16.6702 10.4814 16.7136C9.87325 16.8878 9.25117 16.9058 8.63692 16.7533C7.88964 16.5675 7.3665 16.1206 7.15522 15.4133C6.87912 14.4894 6.93054 13.5978 7.64484 12.8391C7.79127 12.684 7.98466 12.5484 8.1842 12.4611C9.02034 12.0952 9.8794 12.0915 10.7195 12.433C11.5014 12.7507 11.8412 13.3828 11.9161 14.1505C11.9837 14.8462 11.9077 15.5207 11.4159 16.1286H11.4164ZM9.42388 14.9129C9.73688 15.0781 10.0169 15.2258 10.3142 15.3826C10.5127 14.8695 10.5294 14.365 10.378 13.8567C10.2656 13.4808 9.98392 13.2886 9.57926 13.2521C9.18858 13.2166 8.84372 13.3304 8.67269 13.6666C8.37367 14.2548 8.38932 14.8685 8.71182 15.4466C8.88788 15.7627 9.37693 15.8877 9.72234 15.7357C9.53566 15.634 9.36519 15.5419 9.18355 15.4434C9.25844 15.2777 9.32775 15.1242 9.42388 14.9129Z",
    fill: "#252525"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.93025 10.0776C8.45483 8.97809 9.27079 8.27353 10.4821 8.05199C10.717 8.00878 10.962 8.00386 11.2025 8.00331C13.6263 8.00003 16.0501 7.99839 18.474 8.00222C19.9443 8.0044 21.1808 8.86212 21.6511 10.222C21.7619 10.5414 21.7943 10.8872 21.8692 11.2526H20.8637C20.8503 11.1596 20.8329 11.0562 20.8201 10.9528C20.6847 9.85057 19.7189 8.97152 18.5853 8.9666C16.0445 8.95456 13.5038 8.95675 10.9631 8.9666C10.2808 8.96933 9.71037 9.24995 9.27359 9.76578C9.1746 9.8823 9.06834 9.92059 8.92014 9.93536C8.60471 9.96654 8.29209 10.024 7.92969 10.0776H7.93025Z",
    fill: "#252525"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9556 13.5767H16.2929V16.7306H15.0405V16.2663C14.9137 16.3718 14.8282 16.4501 14.7346 16.5195C14.2789 16.8587 13.7606 16.9055 13.2268 16.7249C12.7769 16.5726 12.6007 16.2138 12.588 15.815C12.5651 15.078 12.5812 14.3404 12.5812 13.5854H13.934C13.934 13.6688 13.9334 13.7589 13.934 13.8489C13.9391 14.379 13.9374 14.9097 13.9523 15.4393C13.9598 15.712 14.0964 15.8422 14.3524 15.8685C14.5974 15.8937 14.8219 15.762 14.8861 15.5268C14.9298 15.3688 14.9487 15.202 14.9516 15.0383C14.9596 14.5587 14.9544 14.079 14.9544 13.5762L14.9556 13.5767Z",
    fill: "#252525"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2288 13.5762H22.2482C22.2482 13.8073 22.2588 14.0273 22.2418 14.2452C22.2365 14.3132 22.1665 14.3855 22.1102 14.4391C21.6013 14.9227 21.0887 15.4025 20.5772 15.8834C20.6 15.9174 20.6228 15.952 20.6456 15.986H22.3336V16.8287H19.0834C19.0834 16.5838 19.0755 16.334 19.0887 16.0853C19.0919 16.0242 19.1551 15.9578 19.206 15.9089C19.6862 15.4487 20.1697 14.9923 20.6525 14.5348C20.634 14.5045 20.6149 14.4747 20.5963 14.4444H19.2288V13.5762Z",
    fill: "#252525"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1515 16.8287H17.2222V13.5762H18.1515V16.8287Z",
    fill: "#252525"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2222 13.1109V12.1816H18.1515V13.1109H17.2222Z",
    fill: "#252525"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_1386_680",
    x: -30,
    y: -30,
    width: 90,
    height: 90,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1386_680"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1386_680",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1386_680",
    x1: 2,
    y1: 2,
    x2: 45.0352,
    y2: 56.5959,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.161458,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.4
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuizz);
export default __webpack_public_path__ + "static/media/Quizz.a2d2c9733b0515e9eecadf0439e122bc.svg";
export { ForwardRef as ReactComponent };